import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { right } from '@popperjs/core';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { _ENDPOINT } from '../../../endpoints/endpoint';
import { NetworkService } from '../../../services/network.service';
import { Utility } from '../../../utility/utility';
import { environment } from '../../../../environments/environment';
import { getCountryLabel } from '../../../utility/country.util';

@Component({
  selector: 'app-tariff-and-option-view',
  templateUrl: './tariff-and-option-view.component.html',
  styleUrls: ['./tariff-and-option-view.component.css']
})
export class TariffAndOptionViewComponent implements OnInit, OnDestroy {

  settingsFilter ={
    actions: {
      add: false,
      edit: false,
      delete: false,
    },
    columns: {
      globalCustomerName: {
        title: 'Global Customer Name',
        filter:false
      },
      country: {
        title: 'Country',
        valuePrepareFunction: (country: string) => {
          return getCountryLabel(country);
        },
        filter:false
      },
      localCustomer: {
        title: 'Local Customer',
        filter:false
      },
      localCustomerName: {
        title: 'Local Customer Name',
        filter:false
      },
      catalogName: {
        title: 'Catalog Name',
        filter:false
      },
      lead: {
        title: 'LO',
        filter:false
      },
      owner: {
        title: 'BO',
        filter:false
      }


    },
    pager: {
      display: false
    }
  };

  settings = {
    actions: {
      custom: [
        {
          name: 'bundleProductOffering',
          title: '<i class="fa-solid fa-arrow-right fa-2x" title="Bundled Product Offering"></i>'
        }
      ],
      add: false,
      edit: false,
      delete: false,
      position: right,
      columnTitle: 'View More'
    },
    columns: {
      category:{
        title:'Category'
      },
      type: {
        title: 'Type'
      },
      offeringId: {
        title: 'Product ID'
      },
      offeringName: {
        title: 'Product Name'
      },
      status: {
        title: 'Status'
      },
      startDate: {
        title: 'Start Date',
        compareFunction(direction: any, a: string, b: string) {
          
          let dateObjectA: any;
          let dateObjectB: any;
          if (a) {
            let datePartsA = a.split("/");
            let timePartsA = datePartsA[2].split(" - ")[1].split(":");
            datePartsA[2] = datePartsA[2].split(" - ")[0];
            dateObjectA = new Date(+datePartsA[2], +datePartsA[1] - 1, +datePartsA[0], +timePartsA[0], +timePartsA[1], +timePartsA[2]);
            console.log(dateObjectA);
          }
          if (b && dateObjectA) {
            let datePartsB = b.split("/");
            let timePartsB = datePartsB[2].split(" - ")[1].split(":");
            datePartsB[2] = datePartsB[2].split(" - ")[0];
            dateObjectB = new Date(+datePartsB[2], +datePartsB[1] - 1, +datePartsB[0], +timePartsB[0], +timePartsB[1], +timePartsB[2]);

            console.log(dateObjectB);
          }

          
          if (dateObjectA < dateObjectB) {
            return -1 * direction;
          }
          if (dateObjectA > dateObjectB) {
            return direction;
          }

          return 0;
        }
      },
      endDate: {
        title: 'End Date',
        compareFunction(direction: any, a: string, b: string) {
          
          let dateObjectA: any;
          let dateObjectB: any;
          if (a) {
            let datePartsA = a.split("/");
            let timePartsA = datePartsA[2].split(" - ")[1].split(":");
            datePartsA[2] = datePartsA[2].split(" - ")[0];
            dateObjectA = new Date(+datePartsA[2], +datePartsA[1] - 1, +datePartsA[0], +timePartsA[0], +timePartsA[1], +timePartsA[2]);
            console.log(dateObjectA);
          }
          if (b && dateObjectA) {
            let datePartsB = b.split("/");
            let timePartsB = datePartsB[2].split(" - ")[1].split(":");
            datePartsB[2] = datePartsB[2].split(" - ")[0];
            dateObjectB = new Date(+datePartsB[2], +datePartsB[1] - 1, +datePartsB[0], +timePartsB[0], +timePartsB[1], +timePartsB[2]);

            console.log(dateObjectB);
          }

          
          if (dateObjectA < dateObjectB) {
            return -1 * direction;
          }
          if (dateObjectA > dateObjectB) {
            return direction;
          }

          return 0;
        }
      }


    }
  };

  listTariff: any[] = [];
  listCatalog: any[] = [];
  idCatalog: string;
  idCategory: string;
  destroy$ = new Subject<boolean>();

  constructor(private route: ActivatedRoute, private networkService: NetworkService, private router: Router, private toastr: ToastrManager, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.idCatalog = this.route.snapshot.params['idCatalog'];
    this.initiliazeTariffs();
  }

  onCustomAction(event: any) {
    switch (event.action) {
      case 'bundleProductOffering':
        this.onClickBundledProductOffering(event.data);
        break;
     

    }
  }

  onClickBundledProductOffering(data:any) {
    let url : string =  'bundled-product-offering-view/'+this.idCatalog+'/'+data.productId+'/'+data.category;
    this.router.navigate([url]);
  }

  initiliazeTariffs() {
    this.spinner.show("sp1");
    let urlGetTariffs: string = environment.basePath + _ENDPOINT.getTariffs;
    let request = {
      idCatalog: this.idCatalog
    }
    let data = Utility.createBodyForPostRequest(request, false);
    this.networkService.post(urlGetTariffs, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            let dataJson = JSON.parse(response.body);
            this.listCatalog = dataJson.listCatalog;
            this.listTariff = dataJson.listTariff;
            this.spinner.hide("sp1");
          } else {
            this.spinner.hide("sp1");
            this.toastr.errorToastr('Error during tariffs retrieve!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            this.router.navigate(['catalog-view']);
          }
        }
        else{
          if(response && response.listCatalog && response.listTariff){
            this.listCatalog = response.listCatalog;
            this.listTariff = response.listTariff;
            this.spinner.hide("sp1");
          }else if(response && response.length && response.length>0 ){
            this.spinner.hide("sp1");
            this.toastr.errorToastr(response, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            this.router.navigate(['catalog-view']);
          }else{
            this.spinner.hide("sp1");
            this.toastr.errorToastr('Error during tariffs retrieve!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            this.router.navigate(['catalog-view']);
          }
        }

        
      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during tariffs retrieve!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);
          this.router.navigate(['catalog-view']);
        });;
  }

  goToCatalogView(){
    this.router.navigate(['catalog-view']);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
